import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { DeliverySelectLocation as RedesignStoreDelivery } from '../../../pages';
import { PushAfterLogin } from '../../actions/Actions';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as selectors from '../../redux/user/selectors';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyDelivery } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignStoreDelivery,
  LegacyDelivery,
);

export type StateProps = {
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  CollectionSummaries: Data.Async<Api.CollectionRestaurantSummary[]>;
  Config: Data.Config;
  Customer: Data.Async<Api.Customer>;
  DeliveryLocations: Data.Async<Api.DeliveryLocation[]>;
  deliveryOptions: Store.AsyncMap<Store.DeliveryOption>; // keyed by delivery location id
  DeviceId: string;
  isDark: boolean;
  isLoggedIn: boolean;
  LastRestaurantUrl: string;
  LoggedIn: boolean;
  translate: any;
};

export type DispatchProps = {
  PushLoginUrl: () => any;
};

const mapStateToProps = (state: Store.State): StateProps => ({
  AppConfig: state.flipdish.AppConfig,
  AppDesignScheme: state.appDesignScheme,
  CollectionSummaries: state.flipdish.CollectionSummaries,
  Config: state.flipdish.Config,
  Customer: state.flipdish.Customer,
  DeliveryLocations: state.flipdish.DeliveryLocations,
  deliveryOptions: state.deliveryOptions,
  DeviceId: state.flipdish.Config.DeviceId,
  isDark: state.flipdish.isDark,
  isLoggedIn: selectors.isLoggedIn(state),
  LastRestaurantUrl: state.flipdish.LastRestaurantUrl,
  LoggedIn: state.flipdish.Customer.status === 'success',
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  PushLoginUrl: () => {
    dispatch(PushAfterLogin(window.location.hash.substr(1)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
